
<template>
  <v-row class="align-center pa-1">
    <v-col cols="4" md="2" class="mx-0 pa-0">
      <v-tooltip top color="black" >
        <template v-slot:activator="{on}">
          <v-chip v-on="on" class="ma-1" pill @click="openOrderInNewTab(hf)">
            <v-avatar left :class="financial_data[hf.type].chip[hf.kind].avatar_color">
              <v-icon small color="white">{{financial_data[hf.type].chip[hf.kind].icon}}</v-icon>
            </v-avatar>
            R$ {{Number(hf.ammount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}
          </v-chip>
        </template>
        {{(hf.order_id || hf.external_order_id) ? 'Ver pedido' : (hf.text ? hf.text : hf.comment)}}
      </v-tooltip>
    </v-col>
    <v-col cols='7' >
      <span v-if="hf.returned" class="error--text ma-1">
        <v-icon small color='error'>fa-exclamation-circle</v-icon> Retornado! --
      </span>
      {{ solution_map[hf.solution] }} - {{ hf.place_name }} 
      {{hf.text}} 
      {{hf.comment && (!hf.wholesale_order_id && !hf.other_order_id)? hf.comment : ''}} 
      {{ (hf.wholesale_order_id || hf.other_order_id) ? ' Pedido: #' + (hf.wholesale_order_id || hf.other_order_id) : ''}}
    </v-col>
    <v-col cols='12' class="text-center" md="3">
      {{$moment(hf.payed_at).format('DD/MM/YYYY')}} 
    </v-col>
  </v-row>
</template>

<script>
import SolutionMap from '@/_backoffice/_registrations/mixins/solution_map.js'

export default {
  mixins: [SolutionMap],
  name: 'ItemHistoricHeader',
  props: {
    hf: {
      type: Object,
    },
    is_open: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      financial_data: {
        payment: {
          dot_icon: 'mdi-swap-horizontal-bold',
          dot_color: 'success',
          chip: {
            check: {
              icon: 'mdi-checkbook',
              text: 'Cheque',
              avatar_color: 'green darken-2',
            },
            cash: {
              icon: 'mdi-cash',
              text: 'Dinheiro',
              avatar_color: 'green darken-2',
            },
            bonus: {
              icon: 'mdi-cash-refund',
              text: 'Bônus',
              avatar_color: 'purple darken-2',
            },
            envelope: {
              icon: 'mdi-email',
              text: 'Envelope',
              avatar_color: 'red darken-2',
            },
            pay_devolution: {
              icon: 'mdi-undo',
              text: 'Devolução',
              avatar_color: 'green darken-3',
            },
            envelope: {
              icon: 'mdi-email',
              text: 'Envelope',
              avatar_color: 'green darken-2',
            },
            deposit: {
              icon: 'mdi-receipt',
              text: 'Depósito',
              avatar_color: 'green darken-3',
            },
            deposit_returned: {
              icon: 'mdi-receipt',
              text: 'Depósito',
              avatar_color: 'red darken-3',
            },
            exchange: {
              icon: 'mdi-swap-horizontal',
              text: 'Permuta',
              avatar_color: 'green darken-3',
            },
          },
          icons: {
          },
        },
        bill: {
          dot_icon: 'mdi-swap-horizontal-bold',
          dot_color: 'success',
          chip: {
            bill: {
              icon: 'mdi-barcode',
              text: 'Boleto',
              avatar_color: 'green darken-4',
            },
          },
        },
        pix: {
          dot_icon: 'mdi-swap-horizontal-bold',
          dot_color: 'success',
          chip: {
            pix: {
              icon: 'mdi-qrcode',
              text: 'PIX',
              avatar_color: 'green darken-4',
            },
          },
        },
        vrt_transaction: {
          dot_icon: 'mdi-swap-horizontal-bold',
          dot_color: 'error',
          chip: {
            vrt_transaction: {
              icon: 'mdi-barcode',
              text: 'Boleto',
              avatar_color: 'red darken-3',
            },
          },
        },
        reversal: {
          dot_icon: 'mdi-swap-horizontal-bold',
          dot_color: 'purple darken-3',
          chip: {
            reversal: {
              icon: 'mdi-undo',
              text: 'Estorno',
              avatar_color: 'purple darken-3',
            },
          },
        },

      },
      URL_MAP: {
        'wholesale' : { 
          label: 'Grandes cargas',
          icon: 'mdi-store-settings',
          color: '#E53935',
          kind: 'wholesale',
          link: '',
          development_link: 'http://localhost:3000/order',
          function: (path) => { window.open(path, '_blank'); this.dialog = false }
        },
        'retail' :{ 
          label: 'Galpão',
          icon: 'mdi-cart',
          color: '#E53935',
          kind: 'retail',
          link: '',
          development_link: 'http://localhost:8080/order',
          function: (path) => { window.open(path, '_blank'); this.dialog = false }
        },
      },
    }
  },
  methods: {
    setLinks(){
      let wholesale = {
        production_link: 'https://grandes_cargas.webcimentao.com.br/concluded/order',
        development_link: 'http://localhost:3000/concluded/order',
        qa_link: 'https://grandes_cargas_qa2.webcimentao.com.br/concluded/order',
      }
      let retail = {
        production_link: 'https://galpoes.webcimentao.com.br/order',
        development_link: 'http://localhost:8080/order',
        qa_link: 'https://galpoes-qa.webcimentao.com.br/order',
      }

      let origin = window.location.origin
      let link_check = origin.split('//')[1].split('.')[0].split(':')[0]

      if(link_check == 'gestao-qa' || link_check == 'varejo-m' || link_check == 'grandes_cargas_m'){
        this.URL_MAP['wholesale'].link = wholesale.qa_link
        this.URL_MAP['retail'].link = retail.qa_link
      }else if(link_check == 'webcimentao' || link_check == 'varejo' || link_check == 'gestao'){
        this.URL_MAP['wholesale'].link = wholesale.production_link
        this.URL_MAP['retail'].link = retail.production_link
      }else if(link_check == 'localhost'){
        this.URL_MAP['wholesale'].link = wholesale.development_link
        this.URL_MAP['retail'].link = retail.development_link
      }
    },
    openOrderInNewTab(hf){
      if(hf.order_id || hf.external_order_id){
        let solution = this.hf.solution == 'wholesale' ? "wholesale" : "retail"
        this.URL_MAP[solution].function(`${this.URL_MAP[solution].link}/${solution == 'wholesale' ? hf.order_id : hf.external_order_id}`)
      }
    },
  },
  mounted(){
    this.setLinks()
  }
}
</script>